import { defineComponent as _defineComponent } from 'vue'
import DialogContentLayout from '@/components/common/DialogContentLayout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationRecievedContent',
  emits: ['close'],
  setup(__props, { emit }) {



return { __sfc: true,emit, DialogContentLayout }
}

})